import {useState} from "react";
import ReactFlagsSelect from "react-flags-select";
import {Dropdown} from "semantic-ui-react";
import i18n from "i18next";

const languageMap: {[key: string]: string} = {
  LT: "lt",
  US: "en",
};
interface IProps {
  isAuthed?: boolean;
}

export const LanguageSelector = ({isAuthed = true}: IProps) => {
  const storedLang = localStorage.getItem("lang") || i18n.language || "lt";
  const initialSelected = Object.keys(languageMap).find((key) => languageMap[key] === storedLang) || "LT";
  const [selected, setSelected] = useState(initialSelected);

  const onSelect = (code: string) => {
    const language = languageMap[code];
    setSelected(code);
    localStorage.setItem("lang", language);
    i18n.changeLanguage(language);
  };

  return isAuthed ? (
    <Dropdown.Item className="language-dd" onClick={(e) => e.stopPropagation()}>
      <ReactFlagsSelect
        selectButtonClassName="flag-select-btn"
        countries={["LT", "US"]}
        customLabels={{LT: "Lietuvių", US: "English"}}
        selected={selected}
        onSelect={onSelect}
        selectedSize={13}
        optionsSize={13}
      />
    </Dropdown.Item>
  ) : (
    <ReactFlagsSelect
      countries={["LT", "US"]}
      showSelectedLabel={false}
      customLabels={{LT: "Lietuvių", US: "English"}}
      showOptionLabel={true}
      fullWidth={false}
      alignOptionsToRight={true}
      selected={selected}
      onSelect={onSelect}
      selectedSize={13}
      optionsSize={13}
    />
  );
};
